import { Card, Flex, HStack, Skeleton, SkeletonCircle, VStack } from "@chakra-ui/react";

export const AppModalSkeleton = ({ variant = "default" }: { variant?: "small" | "default" }) => {
  return (
    <Card.Root borderRadius="2xl" bgColor="white" w="full" h={variant === "small" ? "auto" : 190} flex={1}>
      {variant === "small" ? (
        <HStack gap={4} py={4} px={6}>
          <SkeletonCircle size="12" />
          <VStack gap={1} alignItems="flex-start" flex="1">
            <Skeleton height="20px" width="60%" />
            <Skeleton height="16px" width="40%" />
          </VStack>
        </HStack>
      ) : (
        <>
          <Card.Header>
            <Flex justifyContent="space-between">
              <SkeletonCircle size="12" />
              <HStack>
                <Skeleton height="24px" width="48px" borderRadius="full" />
                <Skeleton height="24px" width="24px" borderRadius="full" />
              </HStack>
            </Flex>
          </Card.Header>
          <Card.Body>
            <Skeleton height="20px" width="50%" mb={2} />
            <Skeleton height="32px" width="100%" />
          </Card.Body>
        </>
      )}
    </Card.Root>
  );
};
